<mat-sidenav-container [hasBackdrop]="false">
  <mat-sidenav
    class="sidenav-panel"
    #sidenavstudent
    mode="over"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="isMobile() ? 120 : 64"
    [disableClose]="true"
  >
    <app-add-student 
    [class_id]="class_id"
    (saved)="sidenavstudent.close(); studentAdded($event)"
    (cancelled)="sidenavstudent.close()"
    (loadingSpinner)="loadingStudentSpinner($event)">
    </app-add-student>
  </mat-sidenav>

  <mat-sidenav
    class="sidenav-panel"
    #sidenaveditstudent
    mode="over"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="isMobile() ? 120 : 64"
    [disableClose]="true"
  >
    <app-update-student
    *ngIf="student != null"
    [student]="student"
    (saved)="sidenaveditstudent.close(); studentAdded($event)"
    (cancelled)="sidenaveditstudent.close(); studentCancelled($event)"
    (loadingSpinner)="loadingStudentSpinner($event)">
    </app-update-student>
  </mat-sidenav>
</mat-sidenav-container>

<div fxLayout="row wrap" style="justify-content: space-between" *ngIf="isContributor">
  <div fxLayoutAlign="start center" fxLayoutGap="16px">
    <div>
      <ng-container>
        <br />
        <a mat-raised-button
        color="primary"
        [disabled]="!isAssignStudentViews()"
        (click)="assignTrainings()">
        {{ 'assign_training' | translate }}
        </a>
      </ng-container>
    </div>
    <div>
      <ng-container>
        <br />
        <a mat-raised-button
        color="primary"
        [disabled]="!isSetupStudentViews()"
        (click)="setupTrainings()">
        {{ 'setup_training' | translate }}
        </a>
      </ng-container>
    </div>
    <div>
      <ng-container>
        <br />
        <a mat-raised-button
        color="primary"
        [disabled]="!isCleanupStudentViews()"
        (click)="cleanupTrainings()">
        {{ 'cleanup_training' | translate }}
        </a>
      </ng-container>
    </div>
    <div>
      <ng-container>
        <br />
        <a mat-raised-button
        color="primary"
        [disabled]="!isStreamOnStudentViews()"
        (click)="startStreamings()">
        {{ 'start_streaming' | translate }}
        </a>
      </ng-container>
    </div>
    <div>
      <ng-container>
        <br />
        <a mat-raised-button
        color="primary"
        [disabled]="!isStreamOffStudentViews()"
        (click)="stopStreamings()">
        {{ 'stop_streaming' | translate }}
        </a>
      </ng-container>
    </div>
    <div>
      <ng-container>
        <br />
        <a mat-raised-button
        color="primary"
        [hidden]="!isContributor"
        [disabled]="!isBackfillStudentViews()"
        (click)="resetBackfillDate()">
        {{ 'reset_backfill_date' | translate }}
        </a>
      </ng-container>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" *ngIf="studentsLength !== 0 && studentsLength < 60">
    <div fxLayoutGap="16px">
      <ng-container>
        <br />
        <a mat-raised-button 
        (click)="sidenavstudent.open()"
        color="primary">
        <mat-icon>add</mat-icon> {{ 'add_student' | translate }}
        </a>
        <a mat-raised-button
        color="primary"
        (click)="retrieveTrainings(true)">
        <mat-icon>cached</mat-icon> {{ 'refresh' | translate }}
        </a>
      </ng-container>
    </div>
  </div>
</div>

<br />

<div class="matTable-container mat-elevation-z8" *ngIf=" (media.isActive('lg') || media.isActive('xl') || media.isActive('md')) && studentsLength !== 0 ">
  <mat-table matSort #table [dataSource]="dataSource" class="mat-elevation-z8">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell fxFlex="5%" *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell fxFlex="5%" *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      [disabled]="isCheckBoxView(row)"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Account Name Column -->
    <ng-container cdkColumnDef="account_name">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'account_name' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student"> {{student.account_name}} </mat-cell>
    </ng-container>

    <!-- FirstName Column -->
    <ng-container cdkColumnDef="first_name">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'first_name' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student"> {{student.first_name}} </mat-cell>
    </ng-container>

    <!-- LastName Column -->
    <ng-container cdkColumnDef="last_name">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'last_name' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student"> {{student.last_name}} </mat-cell>
    </ng-container>

    <!-- Email-Id Column -->
    <ng-container cdkColumnDef="email_id">
      <mat-header-cell fxFlex="25%" *cdkHeaderCellDef mat-sort-header> {{ 'student_email' | translate }} </mat-header-cell>
      <mat-cell fxFlex="25%" *cdkCellDef="let student"> {{student.email_id}} </mat-cell>
    </ng-container>

    <!-- Folder Name Column -->
    <ng-container cdkColumnDef="folder_name">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'folder_name' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student"> {{student.folder_name}} </mat-cell>
    </ng-container>

    <!-- Group Name Column -->
    <ng-container cdkColumnDef="group_name">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'group_name' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student"> {{student.group_name}} </mat-cell>
    </ng-container>

    <!-- CONNECT status Column -->
    <ng-container cdkColumnDef="status">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'connect_status' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student">
        <a *ngIf="'Error,ErrorA'.includes(student.status); else noError"
           (click)="viewProcessErrors(student.id)">
          {{ student.status }}
          <mat-icon class="icon-warning">warning</mat-icon>
        </a>
        <ng-template #noError>
          <mat-chip-listbox>
            <mat-chip-option class="application-list-status" [ngClass]="[student.status.toLowerCase()]">{{student.status}}</mat-chip-option>
          </mat-chip-listbox>
        </ng-template>
      </mat-cell>
    </ng-container>

    <!-- CDS status Column -->
    <ng-container cdkColumnDef="cds_status" *ngIf="isDataHubEnabled">
      <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header> {{ 'cds_status' | translate }} </mat-header-cell>
      <mat-cell fxFlex="10%" *cdkCellDef="let student">
        <a *ngIf="student.cds_status === 'Error'; else noError"
           (click)="viewProcessErrors(student.id)">
          {{ student.cds_status }}
          <mat-icon class="icon-warning">warning</mat-icon>
        </a>
        <ng-template #noError>
          <mat-chip-listbox>
            <mat-chip-option class="application-list-status" [ngClass]="[student.cds_status.toLowerCase()]">{{student.cds_status}}</mat-chip-option>
          </mat-chip-listbox>
        </ng-template>
      </mat-cell>
    </ng-container>

    <!-- Stream status Column -->
    <ng-container cdkColumnDef="stream_status" *ngIf="isDataHubEnabled">
      <mat-header-cell fxFlex="5%" *cdkHeaderCellDef mat-sort-header> {{ 'stream_status' | translate }} </mat-header-cell>
      <mat-cell fxFlex="5%" *cdkCellDef="let student">
        <a *ngIf="student.stream_status === 'Error'; else noError"
           (click)="viewProcessErrors(student.id)">
          {{ student.stream_status }}
          <mat-icon class="icon-warning">warning</mat-icon>
        </a>
        <ng-template #noError>
          <mat-chip-listbox>
            <mat-chip-option class="application-list-status" [ngClass]="[student.stream_status.toLowerCase()]">{{student.stream_status}}</mat-chip-option>
          </mat-chip-listbox>
        </ng-template>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="menu">
      <mat-header-cell fxFlex="5%" *cdkHeaderCellDef></mat-header-cell>
      <mat-cell fxFlex="5%" *cdkCellDef="let student">

        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="isContributor">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngIf="isAssignTraining(student)" (click)="assignTraining(student)"
                  matTooltip="Start the process. Once started, the resources will be assigned." matTooltipPosition="left">
            {{ 'assign_training' | translate }}
          </button>
          <button mat-menu-item *ngIf="isSetupTraining(student)" [disabled]="isSetupTrainingView(student)" (click)="setupTraining(student)"
                  matTooltip="Start the process. Once started, the services will be switched on and Cds ." matTooltipPosition="left">
            {{ 'setup_training' | translate }}
          </button>
          <button mat-menu-item *ngIf="isCleanupTraining(student)" [disabled]="isCleanupTrainingView(student)" (click)="cleanupTraining(student)"
                  matTooltip="Start the process. Once started, the resources will be cleanup." matTooltipPosition="left">
            {{ 'cleanup_training' | translate }}
          </button>
          <button mat-menu-item *ngIf="isDeleteStudent(student)" [disabled]="isDeleteStudentView(student)" (click)="confirmDelete(student)"
                  matTooltip="Delete the student. Once deleted, the student will become invalid." matTooltipPosition="left">
            {{ 'delete' | translate }}
          </button>
          <button mat-menu-item *ngIf="isStreamOnStudent(student)" [disabled]="isStreamOnStudentView(student)" (click)="startStreaming(student)"
                  matTooltip="Start streaming the data (streams data, event data, references data...)." matTooltipPosition="left">
            {{ 'start_streaming' | translate }}
          </button>
          <button mat-menu-item *ngIf="isStreamOffStudent(student)" [disabled]="isStreamOffStudentView(student)" (click)="stopStreaming(student)"
                  matTooltip="Stop streaming the data (streams data, event data, references data...)." matTooltipPosition="left">
            {{ 'stop_streaming' | translate }}
          </button>
          <button mat-menu-item *ngIf="isView(student)" (click)="resetStudentStatus(student)"
                  matTooltip="Reset the status of student if freezed in Assigning...,Creating...,Cleaning..." matTooltipPosition="left">
            {{ 'reset_status' | translate }}
          </button>
          <button mat-menu-item (click)="updateEmailId(student)"
                  matTooltip="update the first_name, last_name and email id of student" matTooltipPosition="left">
            {{ 'update_student' | translate }}
          </button>
          <button mat-menu-item (click)="resendInvite(student)"
                  matTooltip="resend the invite for student for registration/login" matTooltipPosition="left">
            {{ 'resend_invite' | translate }}
          </button>
          <button mat-menu-item *ngIf="isForceDeleteStudentView(student)" (click)="forceDelete(student)"
                  matTooltip="force Delete the student from Account" matTooltipPosition="left">
            {{ 'force_delete' | translate }}
          </button>
        </mat-menu>

      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>
  <br />

  <!-- Mobile view -->
  <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md')) && studentsLength !== 0">

    <!-- Select All -->
    <mat-list-item *ngIf="isContributor">
      <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
        Select All
      </mat-checkbox>
    </mat-list-item>

    <mat-divider></mat-divider>

    <!-- Students -->
    <ng-container *ngFor="let student of dataSource.data">

      <mat-list-item class="student-item">

        <!-- Checkbox -->
        <mat-checkbox (click)="$event.stopPropagation()"
                      [disabled]="isCheckBoxView(student)"
                      (change)="$event ? selection.toggle(student) : null"
                      [checked]="selection.isSelected(student)">
        </mat-checkbox>

        <!-- Content -->
        <div class="student-content">

          <div class="student-header">
            <div class="student-name">
              {{student.first_name}} {{student.last_name}}
            </div>

            <button mat-icon-button
                    [matMenuTriggerFor]="mobileMenu"
                    (click)="$event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #mobileMenu="matMenu">
              <button mat-menu-item *ngIf="isAssignTraining(student)"
                      (click)="assignTraining(student)">
                {{ 'assign_training' | translate }}
              </button>

              <button mat-menu-item *ngIf="isSetupTraining(student)"
                      (click)="setupTraining(student)">
                {{ 'setup_training' | translate }}
              </button>

              <button mat-menu-item *ngIf="isCleanupTraining(student)"
                      (click)="cleanupTraining(student)">
                {{ 'cleanup_training' | translate }}
              </button>

              <button mat-menu-item *ngIf="isDeleteStudent(student)"
                      (click)="confirmDelete(student)">
                {{ 'delete' | translate }}
              </button>

              <button mat-menu-item (click)="updateEmailId(student)">
                {{ 'update_student' | translate }}
              </button>

              <button mat-menu-item (click)="resendInvite(student)">
                {{ 'resend_invite' | translate }}
              </button>
            </mat-menu>
          </div>

          <div class="student-info">
            <div><b>Account:</b> {{student.account_name}}</div>
            <div><b>Email:</b> {{student.email_id}}</div>
            <div><b>Group:</b> {{student.group_name}}</div>
          </div>

          <!-- CONNECT STATUS -->
          <div class="status-row">
            <span class="status-label">
              {{ 'connect_status' | translate }}
            </span>

            <ng-container *ngIf="'Error,ErrorA'.includes(student.status); else connectOk">
              <a (click)="viewProcessErrors(student.id)">
                {{ student.status }}
                <mat-icon class="icon-warning">warning</mat-icon>
              </a>
            </ng-container>

            <ng-template #connectOk>
              <mat-chip-listbox>
                <mat-chip-option class="application-list-status"
                                 [ngClass]="student.status?.toLowerCase()">
                  {{student.status}}
                </mat-chip-option>
              </mat-chip-listbox>
            </ng-template>
          </div>

          <!-- CDS STATUS -->
          <div class="status-row" *ngIf="isDataHubEnabled">
            <span class="status-label">
              {{ 'cds_status' | translate }}
            </span>

            <ng-container *ngIf="student.cds_status === 'Error'; else cdsOk">
              <a (click)="viewProcessErrors(student.id)">
                {{ student.cds_status }}
                <mat-icon class="icon-warning">warning</mat-icon>
              </a>
            </ng-container>

            <ng-template #cdsOk>
              <mat-chip-listbox>
                <mat-chip-option class="application-list-status"
                                 [ngClass]="student.cds_status?.toLowerCase()">
                  {{student.cds_status}}
                </mat-chip-option>
              </mat-chip-listbox>
            </ng-template>
          </div>

          <!-- STREAM STATUS -->
          <div class="status-row" *ngIf="isDataHubEnabled">
            <span class="status-label">
              {{ 'stream_status' | translate }}
            </span>

            <ng-container *ngIf="student.stream_status === 'Error'; else streamOk">
              <a (click)="viewProcessErrors(student.id)">
                {{ student.stream_status }}
                <mat-icon class="icon-warning">warning</mat-icon>
              </a>
            </ng-container>

            <ng-template #streamOk>
              <mat-chip-listbox>
                <mat-chip-option class="application-list-status"
                                 [ngClass]="student.stream_status?.toLowerCase()">
                  {{student.stream_status}}
                </mat-chip-option>
              </mat-chip-listbox>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-list>

  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="isContributor && studentsLength === 0">
    <div style="padding-top: 100px;">
      <img src="../../../assets/imgs/student.png" style="height: 80px; width: 80px;" />
    </div>
    <br />
    <div class="sub-title">{{ 'no_student' | translate }}</div>
    <br />
    <div fxLayoutAlign="space-between center">
      <a mat-raised-button
         color="primary"
         (click)="sidenavstudent.open()">
        {{ 'add_student' | translate }}
      </a>
    </div>
  </div>
